import React from "react";
import { Form } from "react-bootstrap";
import { withTranslation, WithTranslation } from "react-i18next";
import { OutputSettingsBaseCard, OutputSettingsBaseCardProps } from "./OutputSettingsBaseCard";
import { EventGuestStatistic, GuestStatistic } from "../../../../models/Event";

interface GuestFilter {
    key: string;
    name: string;
    statisticGetter: (value: EventGuestStatistic) => GuestStatistic;
}

interface GuestsCardProps extends OutputSettingsBaseCardProps, WithTranslation {}

class GuestsCardComponent extends OutputSettingsBaseCard<GuestsCardProps> {
    private getGuestFilters(): GuestFilter[] {
        const { t } = this.props;
        return [
            { key: "ALL", name: t("cards.guests.filterOptions.ALL"), statisticGetter: (statistic) => statistic.all },
            {
                key: "CHECKED_IN",
                name: t("cards.guests.filterOptions.CHECKED_IN"),
                statisticGetter: (statistic) => statistic.attended,
            },
            {
                key: "ACCEPTED",
                name: t("cards.guests.filterOptions.ACCEPTED"),
                statisticGetter: (statistic) => statistic.accepted,
            },
        ];
    }

    protected getTitleTranslationKey(): string {
        return "cards.guests.title";
    }

    protected renderCardBody(): React.ReactNode {
        const { outputSettings, eventGuestStatistic, t } = this.props;
        const guestFilters = this.getGuestFilters();
        const buildLabel = (filter: GuestFilter) => {
            return filter.name + (eventGuestStatistic ? ": " + filter.statisticGetter(eventGuestStatistic).count : "");
        };
        return (
            <Form.Group className="mb-3">
                <Form.Label>{t("cards.guests.filterLabel")}</Form.Label>
                {guestFilters.map((filter) => (
                    <Form.Check
                        type="radio"
                        key={filter.key}
                        id={filter.key}
                        name="guestFilter"
                        label={buildLabel(filter)}
                        checked={outputSettings.guestFilter === filter.key}
                        onChange={() => this.handleSettingChange("guestFilter", filter.key)}
                        className="mb-2"
                    />
                ))}
                <Form.Text className="text-muted">{t("cards.guests.description")}</Form.Text>
            </Form.Group>
        );
    }
}

export const GuestsCard = withTranslation("wizard")(GuestsCardComponent);
